import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addBankTransfer = catchAsync(async ({ ac, pe }) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.transfer_to_bank?ac=${ac}&pe=${pe}`
  );
  return data;
});
